import { createRef, useEffect, useState } from "react";
import { Col, Row, Spinner, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import CaminhaoLayout from "../layout/CaminhaoLayout";
import Loading from "../../loading/Loading";
import BodyRowCaminhoes from "../../table/body/BodyRowCaminhoes";
import HeadTable from "../../table/head/HeadRow";
import { getAllData, getCaminhoes } from "../../../services/Servicos";
import { update, updateCaminhoes, updateTransportadorasList } from "../../../redux/slicers/user";
import ScrollbarLeft from "../../scrollbars/ScrollbarLeft";
import {
	filtroDinamicoArrays,
	removerDadosDuplicados,
} from "../../../services/helpers";

const headList = [
	"index",
	"admin",
	"Atribuir",
	"status",
	"tipo",
	"tipo_cavalo",
	"placa",
	"id_filial",
	"comprimento",
	"largura",
	"altura",
	"qtd_eixos",
	"capacidade",
	"pbt",
	"tara",
	"trator",
	"vencimento_tacografo",
	"equipamentos",
];
const tbodyRef = createRef();
const tableDiv = createRef();

export default function CaminhaoCadastrado() {
	const caminhoes = useSelector((state) => state.userSlice.caminhoesList);

	const [loading, setLoading] = useState(false);
	const [indexList, setIndexList] = useState(10);
	const [filteredTable, setFilteredTable] = useState(false);
	const [filters, setFilters] = useState([]);
	const user = useSelector((state) => state.userSlice);
	const dispatch = useDispatch();

	useEffect(() => {
		const refTable = tableDiv.current;
		const scrollHandler = (e) => {
			const tbodyHeight = tbodyRef.current.clientHeight;
			const scrollPosition = e.target.scrollTop;
			const tableHeight = e.target.clientHeight;

			if (scrollPosition >= tbodyHeight - tableHeight) {
				setTimeout(() => {
					setIndexList(indexList + 10);
				}, 1000);
			}
		};

		refTable.addEventListener("scroll", scrollHandler, false);

		return () => refTable.removeEventListener("scroll", scrollHandler, false);
	});

	const onClickRemoveFilter = (e) => {
		e.preventDefault();
		const value = e.target.parentNode.firstElementChild.innerText;
		const [key, keyValue] = value.split(":");
		//
		setFilters((last) => [
			...last.filter(
				(item) =>
					String(item[key]).replaceAll(" ", "") !== keyValue.replaceAll(" ", "")
			),
		]);
	};

	const [filtersNew, setFiltersNew] = useState({});
	useEffect(() => {
		if (!filters.length) {
			setIndexList(10);
			setFilteredTable(false);
			return;
		}

		let testeFilters = {};

		filters.forEach((ele) => {
			// testeFilters[arguments[ele]]
			const param = Object.getOwnPropertyNames(ele)[0];
			testeFilters[param] = [];
		});

		filters.forEach((ele) => {
			// testeFilters[arguments[ele]]
			const param = Object.getOwnPropertyNames(ele)[0];
			// testeFilters[param].push(ele[param])
			testeFilters[param].push(String(ele[param]).toLowerCase());

			if (String(ele[param]).toLowerCase() == "false") {
				testeFilters[param].push("null");
			}
		});

		let arrayRetorno = [caminhoes.data];

		Object.keys(testeFilters).forEach((key, index) => {
			arrayRetorno.push(
				filtroDinamicoArrays(
					testeFilters,
					key,
					arrayRetorno[arrayRetorno.length - 1]
				)
			);
		});

		const arrayF = removerDadosDuplicados(
			arrayRetorno[arrayRetorno.length - 1],
			"placa"
		);
		setFilteredTable(arrayF.reverse());
	}, [filters]);
	
	const updateCaminhoesListArray = async () => {
		await getCaminhoes(user.tipo)
			.then((response) => {
				dispatch(updateCaminhoes(response));
				setLoading(false);
			})
			.catch((error) => {
				if (error.msg.toLowerCase() === "unauthorized") {
					dispatch(update({ authenticated: false }));
				}
			});

	}
	const updateTransportadoraListArray = async () => {
		await getAllData("transportadoras")
			.then((response) => {
				dispatch(updateTransportadorasList(response.data));
			})
	};

	useEffect(() => {
		Promise.all([
			updateCaminhoesListArray(),
			updateTransportadoraListArray(),
		])
	}, []);

	return (
		<CaminhaoLayout>
			<div className="section-filters-table">
				<h3>Filtrar Caminhões</h3>
				<hr />

				<Row className="mt-2 row-filters">
					<Col>
						<div>
							{filters.map((item, key) =>
								Object.keys(item).map((key, index) => {
									return (
										<span className="filters-card" key={index}>
											<span className="filters">
												<span className="title">
													{key}: {item[key]}
												</span>
												<i
													className="bi bi-x-lg"
													onClick={onClickRemoveFilter}
												></i>
											</span>
										</span>
									);
								})
							)}
						</div>
					</Col>
				</Row>
			</div>
			<div className="section-filters-table">
				<div>
					<h3 style={{ display: "flex", alignItems: "center" }}>
						Tabela de Caminhões{" "}
						{loading ? (
							<Spinner
								style={{ marginLeft: "10px", fontSize: "1rem" }}
								animation="border"
								size="sm"
							/>
						) : (
							""
						)}
					</h3>
				</div>
				<hr />

				<div
					className="responsive-table"
					ref={tableDiv}
					style={{ position: "relative", height: "600px", maxHeight: "unset" }}
				>
					<ScrollbarLeft
						tableRef={tableDiv}
						coluna2={2}
						maxima_distancia={50}
					/>
					<Table hover size="sm">
						<thead style={{ zIndex: 49 }}>
							<HeadTable
								rota="frota"
								arrayValues={caminhoes.data}
								headerList={headList}
								setArrayFilters={setFiltersNew}
								arrayFilters={filtersNew}
								setFiltersOld={setFilters}
								filtersOld={filters}
							/>
						</thead>

						<tbody ref={tbodyRef}>
							{filteredTable
								? filteredTable.map((item, index) => {
										if (index < indexList) {
											return (
												<BodyRowCaminhoes
													key={index}
													bodyList={item}
													headList={headList}
													index={index}
												/>
											);
										}
								  })
								: caminhoes.data.map((item, index) => {
										if (index < indexList) {
											return (
												<BodyRowCaminhoes
													key={index}
													bodyList={item}
													headList={headList}
													index={index}
												/>
											);
										}
								  })}
						</tbody>
					</Table>
					{/* CASO NÃO HAJA MAIS VENDAS, REMOVER LOADING  */}
					{filteredTable ? (
						indexList < filteredTable.length ? (
							<Loading color={"black"} msg="Loading" />
						) : (
							""
						)
					) : indexList < caminhoes.data.length ? (
						<Loading color={"black"} msg="Loading" />
					) : (
						""
					)}
				</div>
			</div>
		</CaminhaoLayout>
	);
}
